module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-it-IT.4218af9c.jpg";